document.addEventListener("DOMContentLoaded", () => {
	const expandables = document.querySelectorAll('.expandable');

	expandables.forEach((expandable) => {
		expandable.addEventListener('click', function(e) {
			const title = this.querySelector('.expandable-title');
			const desc = this.querySelector('.expandable-description');

			title.classList.toggle('active');

			if (desc.style.display === "none" || desc.style.display === "") {
				desc.style.display = "block";
			} else {
				desc.style.display = "none";
			}
		});
	});
});
